import { deserialize } from "libs/cerialize";
import { Guid } from "Core/Common/Guid";

export class MessageDto {
    @deserialize
    Role: string;

    @deserialize
    Content: string;

    Id: string = Guid.NewGuid();
}
